import Card from '../components/ui/Card';
import Reveal from '../components/ui/Reveal';
import { Section, SectionHeading } from '../components/ui/Section';
import Button from '../components/ui/Button';
import { FREE_TRIAL_MESSAGE, whatsappLink } from '../config/site';

/*
 * Reassurance section.
 *
 * This replaces the previous testimonial carousel, whose eight named reviews
 * were not verifiable and rendered a French flag for reviewers listed as being
 * in Morocco, Belgium and Canada. Every claim below restates a commitment made
 * elsewhere on this page (guarantee, delivery window, support hours, payment
 * methods) rather than presenting unverifiable social proof.
 */
const GUARANTEES = [
    {
        title: 'Testez avant de payer',
        body: "Un test gratuit de 24 h vous donne accès au catalogue complet. Vous jugez la stabilité et la qualité d'image avant tout engagement.",
        icon: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z',
    },
    {
        title: 'Garantie de remboursement',
        body: "15 jours sur les forfaits standard, 30 jours sur le forfait à vie. Si un problème technique ne peut pas être résolu, vous êtes remboursé.",
        icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
    },
    {
        title: 'Paiement sécurisé',
        body: 'Carte bancaire, PayPal, Bancontact, Apple Pay, Google Pay et crypto. Toutes les transactions passent par des prestataires chiffrés.',
        icon: 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
    },
    {
        title: 'Assistance humaine 7j/7',
        body: "Une question de configuration ou une coupure ? Notre équipe répond directement sur WhatsApp, tous les jours de la semaine.",
        icon: 'M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414',
    },
];

export default function Trust() {
    return (
        <Section id="garanties">
            <SectionHeading
                eyebrow="Vos garanties"
                title="Ce sur quoi vous pouvez compter"
                description="Aucun engagement, aucun prélèvement automatique. Voici précisément ce que couvre votre commande."
            />

            <div className="grid gap-5 sm:grid-cols-2">
                {GUARANTEES.map((guarantee, index) => (
                    <Reveal key={guarantee.title} delay={index * 80}>
                        <Card interactive className="flex h-full gap-5 p-6 sm:p-7">
                            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-line-brand bg-brand/[0.08] text-brand">
                                <svg
                                    className="h-5 w-5"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    aria-hidden="true"
                                >
                                    <path d={guarantee.icon} />
                                </svg>
                            </span>
                            <div>
                                <h3 className="font-bold text-white">{guarantee.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-content-muted text-pretty">
                                    {guarantee.body}
                                </p>
                            </div>
                        </Card>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={200} className="mt-10 text-center">
                <p className="text-content-muted">
                    Le meilleur moyen de vous faire un avis reste de tester le service.
                </p>
                <Button
                    href={whatsappLink(FREE_TRIAL_MESSAGE)}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outline"
                    className="mt-4"
                >
                    Obtenir mon test gratuit de 24 h
                </Button>
            </Reveal>
        </Section>
    );
}
